import { useState, useEffect, type FormEvent } from "react";
import { useNavigate } from "react-router";
import { Button, Input, FormField, Heading } from "@/components/ds";
import { useSignupWizard } from "./SignupWizardProvider";
import styles from "./SignupPasswordStep.module.css";

export function SignupPasswordStep() {
  const navigate = useNavigate();
  const { email, setPassword } = useSignupWizard();
  const [localPassword, setLocalPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmError, setConfirmError] = useState("");

  useEffect(() => {
    if (!email) {
      navigate("/signup", { replace: true });
    }
  }, [email, navigate]);

  if (!email) return null;

  function handleSubmit(event: FormEvent) {
    event.preventDefault();
    let valid = true;

    if (localPassword.length < 8) {
      setPasswordError("Password must be at least 8 characters");
      valid = false;
    } else {
      setPasswordError("");
    }

    if (localPassword !== confirmPassword) {
      setConfirmError("Passwords do not match");
      valid = false;
    } else {
      setConfirmError("");
    }

    if (!valid) return;

    setPassword(localPassword);
    navigate("/signup/name");
  }

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <Heading level={1} size="h3">Choose a password</Heading>

      <FormField
        label="Password"
        htmlFor="signup-password"
        error={passwordError}
        hint="At least 8 characters"
      >
        <Input
          type="password"
          name="password"
          id="signup-password"
          value={localPassword}
          onChange={(e) => {
            setLocalPassword(e.target.value);
            setPasswordError("");
          }}
          error={!!passwordError}
          required
        />
      </FormField>

      <FormField
        label="Confirm password"
        htmlFor="signup-confirm-password"
        error={confirmError}
      >
        <Input
          type="password"
          name="confirmPassword"
          id="signup-confirm-password"
          value={confirmPassword}
          onChange={(e) => {
            setConfirmPassword(e.target.value);
            setConfirmError("");
          }}
          error={!!confirmError}
          required
        />
      </FormField>

      <Button type="submit" fullWidth>Continue</Button>
    </form>
  );
}
